<template>
  <div class="row">
      <div class="col-md-12 card">
          <div class="card-header">
            <div class="row">
                <div class="col-md-4">
                  <h5>{{ $t('farmers') }} </h5>
                </div>
                <div class="col-md-4">
                 <fg-input>
                    <el-select size="large" class="select-primary" v-model="country" filterable clearable :placeholder="$t('select_country')">
                        <el-option
                          class="select-primary"
                          v-for="country in Countries"
                          :key="country.id"
                          :label="country.name"
                          :value="country.name"></el-option>
                    </el-select>
                 </fg-input>
               </div>
               <div class="col-md-4">
                  <fg-input>
                      <el-select size="large" class="select-primary" v-model="ngo" filterable clearable :placeholder="$t('select_ngo')">
                          <el-option
                            class="select-primary"
                            v-for="ngo in NGO"
                            :key="ngo.id"
                            :label="ngo.name"
                            :value="ngo.name"></el-option>
                      </el-select>
                  </fg-input>
               </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
                <div class="col-md-6">
                  <el-select v-model="pagination.perPage" :placeholder="$t('per_page')">
                    <el-option
                      class="select-default"
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item">
                      </el-option>
                  </el-select>
                </div>
                <div class="col-sm-6">
                  <div class="pull-right">
                    <fg-input
                      class="input-sm" :placeholder="$t('search')" v-model="searchQuery"
                      addon-right-icon="nc-icon nc-zoom-split"
                    ></fg-input>
                  </div>
                </div>
             </div>
             <div class="row">
                  <el-table v-loading="loading" :element-loading-text="$t('loading_data')+'...'" class="table-striped" :data="paginated" border style="width: 100%">
                    <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth"
                      :prop="column.prop" :label="column.label" sortable="">
                    </el-table-column>
                    <el-table-column fixed="right" class-name="td-actions text-center" :label="$t('actions')">
                       <template slot-scope="props">
                            <p-button type="success" size="sm" icon title="Click to view farmer details" @click="viewDetails(props.$index, props.row)">
                               <i class="fa fa-eye"></i>
                            </p-button>
                       </template>
                    </el-table-column>
                  </el-table>
             </div>
          </div>
          <div class="card-footer">
            <paginate :pagination="pagination" :metadata="metaData" :allData="getUserFarmers"></paginate>
          </div>
      </div>

  </div>
</template>
<script>
import Resource from "@/util/Api/resource.js";
import PPagination from "src/components/UIComponents/Pagination.vue";
import Paginate from '@/components/UIComponents/Paginate.vue';
import Con from "@/util/helpers.js";

const CatResources = new Resource("category/childrenGivenParent");
const PostRefineResource = new Resource("post/trainsers/farmers/Farmer/0");

export default {
  components:{
     PPagination,
     Paginate
  },
  data() {
    return {
       country:'',
       ngo:'',
       searchQuery: '',
       Countries: [],
       NGO: [],
       tableData: [],
       farmerUsers:[],
       farm: {
          id:'',
          name:'',
          profile:'',
          email:'',
          phone:'',
          hectares:'',
          people:'',
          harvest:'',
          ngo:'',
          country:'',
          community:'',
          postTemplateID:'',
       },
       tableColumns: [
          {prop: "name", label: this.$t("full_name"), minWidth: "150"},
          {prop: "email", label: this.$t("email"),  minWidth: "100"},
          {prop: "phone", label: this.$t("phone")},
          {prop: "community", label: this.$t("community"), minWidth: "200"},
          {prop: "country", label: this.$t("country")},
          {prop: "ngo", label: this.$t("ngo")},
        ],
        pagination:{
            perPage: 10,
            perPageOptions: [10, 20, 30, 60, 500, 1000],
            currentPage:1,
            nextPage:'',
            prevPage:'',
            total:'',
            from:'',
            to:'',
            page:'',
        },
        metaData: {
           meta:'',
           links:''
        },
        loading: false,
    }
  },
  created() {
      this.getNGOs();
      this.getCountry();
      this.getUserFarmers();
  },
  computed: {
    filterData() {
        let result = this.tableData;
        if (this.searchQuery) {
            result = result.filter((row) => {
                return Object.keys(row).some((key) => {
                    return (String(row[key]).toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1);
                })
            });
        } else if(this.country){
          result = result.filter((row) => {
                return Object.keys(row).some((key) => {
                    return (String(row[key]).toLowerCase().indexOf(this.country.toLowerCase()) > -1);
                })
          });
        } else if(this.ngo){
          result = result.filter((row) => {
                return Object.keys(row).some((key) => {
                    return (String(row[key]).toLowerCase().indexOf(this.ngo.toLowerCase()) > -1);
                })
          });
        }
        return result;
    },

    paginated() {
        return this.paginate(this.filterData, this.pagination.perPage, this.pagination.currentPage);
    },
  },
  methods: {
    // Get all NGOs in a categories
    async getNGOs() {
      await CatResources.get(1).then(response => {
         this.NGO = response.data;
      }).catch(error => {
         this.showAlertMessage(error.response.data.message, "error");
      });
    },

    // Get all countries in a category
    async getCountry() {
      await CatResources.get(2).then(response => {
         this.Countries = response.data;
      }).catch(error => {
         this.showAlertMessage(error.response.data.message, "error");
      });
    },

    // Parse data
    parseAnswer(answer) {
        let data = "";
        if(answer.indexOf('"') > -1) {
           data = JSON.parse(answer);
        } else {
           data = answer;
        }
        return data;
    },

    // Format farmers data
    formatFarmersData(data) {
      this.farmerUsers = [];
      data.forEach((user, index) => {

      this.farm = [];
      this.farm.id = user.post.id;
      this.farm.postTemplateID = user.post.postTemplateID;

          user.postContent.forEach((element, key) => {
                if(element.Question.title.toLowerCase() === "name") {
                    if(element.Answer) {
                      this.farm.first_name = this.parseAnswer(element.Answer);
                    } else {
                      this.farm.first_name = "";
                    }
                }

                if(element.Question.title.toLowerCase() === "surname") {
                    if(element.Answer) {
                      this.farm.last_name = this.parseAnswer(element.Answer);
                    } else {
                      this.farm.last_name = "";
                    }
                }

                if(element.Question.title.toLowerCase() === "email") {
                    if(element.Answer) {
                      this.farm.email = this.parseAnswer(element.Answer);
                    } else {
                      this.farm.email = "";
                    }
                }

                if(element.Question.title.toLowerCase() === "phone number") {
                    if(element.Answer) {
                      this.farm.phone = this.parseAnswer(element.Answer);
                    } else {
                      this.farm.phone = "";
                    }
                }

                if(element.Question.title.toLowerCase() === "profile image") {
                    if(element.Answer) {
                      this.farm.profile = this.parseAnswer(element.Answer);
                    } else {
                      this.farm.profile = "";
                    }
                }

                if(element.Question.title.toLowerCase() === "hectares") {
                  if(element.Answer) {
                      this.farm.hectares = this.parseAnswer(element.Answer);
                    } else {
                      this.farm.hectares = "";
                    }
                }

                if(element.Question.title.toLowerCase() === "people") {
                    if(element.Answer) {
                      this.farm.people = this.parseAnswer(element.Answer);
                    } else {
                      this.farm.people = "";
                    }
                }

                if(element.Question.title.toLowerCase() === "select ngo") {
                    if(element.Answer) {
                      this.farm.ngo = this.parseAnswer(element.Answer);
                    } else {
                      this.farm.ngo = "";
                    }
                }

                if(element.Question.title.toLowerCase() === "select country") {
                    if(element.Answer) {
                      this.farm.country = this.parseAnswer(element.Answer);
                    } else {
                      this.farm.country = "";
                    }
                }

                if(element.Question.title.toLowerCase() === "community") {
                    if(element.Answer) {
                      this.farm.community = this.parseAnswer(element.Answer);
                    } else {
                      this.farm.community = "";
                    }
                }
          });

          this.farm.name = this.farm.first_name + " " + this.farm.last_name;
          this.farmerUsers.push(this.farm);

      });

      let filterData = [];

      this.farmerUsers.forEach((value) => {
        if(value.first_name !== undefined) {
           filterData.push(value);
        }
      });


      this.tableData = [...filterData, ...this.tableData];
    },

    // getting all farmers data
    async getUserFarmers(page_url) {
      this.searchQuery = '';
      this.loading = true;
      if(page_url) {
         page_url = Con.splitStringLinks(page_url);
      }
      await PostRefineResource.list(page_url)
        .then(response => {
            this.formatFarmersData(response.data.data);
            this.metaData.meta = response.data.meta;
            this.metaData.links = response.data.links;
            this.loading = false;
        }).catch(error => {
            this.loading = false;
            console.log(error);
        });
    },

    // function to view a single farmers details
    async viewDetails(index, row){
      localStorage.setItem("farmerID", row.id);
      localStorage.setItem("postTemplateID", row.postTemplateID);
      localStorage.setItem("showButton", 1)
      this.$router.push({
           name: "FarmersDetails",
           params: { post: row }
      });
    },

    paginate(array, length, pageNumber){
        this.pagination.from = array.length ? ((pageNumber - 1) * length) + 1 : ' ';
        this.pagination.to = pageNumber * length > array.length ? array.length : pageNumber * length;
        this.pagination.prevPage = pageNumber > 1 ? pageNumber : '';
        this.pagination.nextPage = array.length > this.pagination.to ? pageNumber + 1 : '';
        this.pagination.page = Math.ceil(array.length / length);
        this.pagination.total = array.length;
        return array.slice((pageNumber - 1) * length, pageNumber * length);
    },

  },
}
</script>
